import Loadable from 'UIComponents/decorators/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
const AsyncVerifyScriptPromptCheck = Loadable({
  loader: () => import( /* webpackChunkName: "verify-install-prompt" */'../../verify-install/components/VerifyScriptPromptCheck'),
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ ({ minHeight, LoadingIndicator, }: Props):... Remove this comment to see the full error message
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentError
});
export default AsyncVerifyScriptPromptCheck;